import React, {useState} from "react"
import { Link } from "gatsby"
import PWMarkdown from '../common/PWMarkdown';
import ShareImage from '../../images/icons/share.png'
import LikeImage from '../../images/icons/like.png'
import ArrowIcon from '../../images/icons/arrow-circle.png' 
import ArrowImage from "../../images/icons/arrow.png"
import SocialShare from '../common/SocialButtons';
import LikeIconActive from '../../images/icons/like-active.png';
import { api } from '../../../utils';
import "./wide-wise-tip.scss"

const WideWiseTipCard = ({ data, customTip, location, user, bookmarks, fetchBookmarks }) => {
    const [openCls, setOpenCls] = useState(false)

    if (!data || data.status !== 'publish') {
        return null;
    }

    const bookmarkTip = (slug) => {
        const fData = {
            type: 'wise-tip',
            slug
        }
        api.post('/api/v1/user-bookmark/toggle', fData)
        .then(resp => {
            if (resp && resp.success) {
                fetchBookmarks();
            } else {
                alert("Something went wrong. Please try again later!");
            }
        });
    }

    const getDomains = (data) => {
        if (!data || !data.nodes || !data.nodes.length) {
            return null;
        }
        let domains = [];
        data.nodes.forEach(item => {
            if (!item.parentDatabaseId) {
                return;
            }
            domains.push(item.name)
        });

        return domains.join(', ');
    }

    const getParentDomain = (data) => {
        if (!data || !data.nodes || !data.nodes.length) {
            return null;
        }
        let domains = [];
        data.nodes.forEach(item => {
            if (item.parentDatabaseId) {
                return;
            }
            domains.push(item.name)
        });

        return domains.join(', ');
    }

    const getCategories = (data, key) => {
        if (!data || !data.nodes || !data.nodes.length) {
            return null;
        }
        let categoryList = [];
        data.nodes.forEach(item => {
            categoryList.push(item[key])
        });

        return categoryList.join(', ');
    }

    return (
        <Link to={`/${(data.acf_wise_tip.type === 'coreFinding') ? 'core-finding' : 'wise-tip'}/${data.slug}`}>
            <div className="wide-wise-tip-mainCard">
                <div className="w3-col m12 s12">
                    <div className='w3-col s12 w3-white wide-wise-tip-card' style={(data.acf_wise_tip.type === 'coreFinding') ? { border: `2px solid ${data.acf_wise_tip.themeColor}`} : {}}>
                        
                            <div className="wide-wise-tip-header" style={{ color: `${data.acf_wise_tip.themeColor}` }}>{getParentDomain(data.domains)}</div>
                            <div className="wide-wise-tip-subHeader" style={{ color: `${data.acf_wise_tip.themeColor}` }}>{getDomains(data.domains)}</div>
                            <div className="wide-wise-tip-border" style={{ borderBottomColor: `${data.acf_wise_tip.themeColor}` }}></div>
                            <div className="wide-wise-tip-title">{data.title}</div>
                            <div className="w3-hide-medium w3-hide-large">
                                <div className='w3-col s11 wide-wise-tip-content'>
                                    <PWMarkdown data={(customTip) ? customTip : data.acf_wise_tip.tip} />
                                </div>
                                <div className='allign w3-col s1'>
                                    <img src={ArrowImage} />
                                </div>
                            </div>
                            <div className='wide-wise-tip-content w3-hide-small'>
                                <PWMarkdown data={(customTip) ? customTip : data.acf_wise_tip.tip} />
                            </div>
                            <div className="w3-col">
                                <div className='wide-wise-tip-arrow w3-hide-small w3-left'>
                                    <img src={ArrowIcon} />
                                </div>
                                {(data.acf_wise_tip.type === 'coreFinding') && (
                                    <div className='wide-wise-tip-allign w3-right'>
                                        <div className={`w3-margin-right w3-margin-top`}> 
                                            {(user) && (
                                                <button style={{ background: 'none', padding: '0px', border: 'none', outline: 'none', cursor: 'pointer' }}
                                                    onClick={(evt) => {
                                                        evt.preventDefault();
                                                        evt.stopPropagation();
                                                        bookmarkTip(data.slug);
                                                    }}
                                                > 
                                                    <img src={(bookmarks.indexOf(data.slug) !== -1) ? LikeIconActive : LikeImage}
                                                        style={{width: "25px"}}
                                                    />
                                                </button>
                                            )}
                                        </div>
                                        <div className={`share-img w3-margin-top ${openCls == false ? "w3-show" : "w3-hide"}`}> 
                                            <img src={ShareImage} onClick={(evt) => {
                                                evt.preventDefault();
                                                evt.stopPropagation();
                                                setOpenCls(true)
                                            }} /> 
                                        </div>
                                        <SocialShare data={openCls} handleSetOpenCls={(someData) => {setOpenCls(someData)}} 
                                            title={data.title} link={`${location.origin}/${(data.acf_wise_tip.type === 'coreFinding') ? 'core-finding' : 'wise-tip'}/${data.slug}`} 
                                            subjectTitle={`Check out this ${(data.acf_wise_tip.type === 'coreFinding') ? 'Core Finding' : 'tip'}!`} description={(customTip) ? customTip : data.acf_wise_tip.tip}
                                        />
                                    </div>
                                )}
                            </div>
                        
                        {(data.acf_wise_tip.type !== 'coreFinding') && 
                            <div className='w3-col s6 w3-margin-top'>
                                <div className="wide-wise-tip-duration">{getCategories(data.ageStages, 'description')}</div>
                                <div className="wide-wise-tip-play">{getCategories(data.contexts, 'name')}</div>
                            </div>
                        }
                        
                        {(data.acf_wise_tip.type !== 'coreFinding') && (
                            <div className='wide-wise-tip-allign w3-col s6 w3-margin-top'>
                                <div className={`w3-margin-right`}> 
                                    {(user) && (
                                        <button style={{ background: 'none', padding: '0px', border: 'none', outline: 'none', cursor: 'pointer' }}
                                            onClick={(evt) => {
                                                evt.preventDefault();
                                                evt.stopPropagation();
                                                bookmarkTip(data.slug);
                                            }}
                                        > 
                                            <img src={(bookmarks.indexOf(data.slug) !== -1) ? LikeIconActive : LikeImage}
                                                style={{width: "25px"}}
                                            />
                                        </button>
                                    )}
                                </div>
                                <div className={`share-img ${openCls == false ? "w3-show" : "w3-hide"}`}> 
                                    <img src={ShareImage} onClick={(evt) => {
                                        evt.preventDefault();
                                        evt.stopPropagation();
                                        setOpenCls(true)
                                    }} /> 
                                </div>
                                <SocialShare data={openCls} handleSetOpenCls={(someData) => {setOpenCls(someData)}} 
                                    title={data.title} link={`${location.origin}/${(data.acf_wise_tip.type === 'coreFinding') ? 'core-finding' : 'wise-tip'}/${data.slug}`} 
                                    subjectTitle={`Check out this ${(data.acf_wise_tip.type === 'coreFinding') ? 'Core Finding' : 'tip'}!`} description={(customTip) ? customTip : data.acf_wise_tip.tip}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default WideWiseTipCard;